const PREFIX = "AGROEVIDENCE";

export const GET_COUNTRIES_REQUEST = `${PREFIX}/GET_COUNTRIES_REQUEST`;
export const GET_COUNTRIES_SUCCESS = `${PREFIX}/GET_COUNTRIES_SUCCESS`;
export const GET_COUNTRIES_ERROR = `${PREFIX}/GET_COUNTRIES_ERROR`;

export const RESET_COUNTRIES = `${PREFIX}/RESET_COUNTRIES`;
